import React, { useMemo } from 'react';
import {
  ScionVault,
  ScyVault,
  ScyVaultPageTabs,
  ScionVaultPageTabs,
} from '@components';
import { useVaultType, VaultType } from '@sc1/common';

export const VaultPage = () => {
  const { vaultType } = useVaultType();
  return useMemo(() => {
    switch (vaultType) {
      case VaultType.SCYVault:
        return (
          <>
            <ScyVaultPageTabs tab="vault" mb={3} />
            <ScyVault />
          </>
        );
      case VaultType.ScionVault:
        return (
          <>
            <ScionVaultPageTabs tab="vault" mb={3} />
            <ScionVault />
          </>
        );
      default:
        return null;
    }
  }, [vaultType]);
};
